import { BaseRouteService } from "./BaseRouteService";

/**
 * Service to handle anything player related
 */
export class InventoryService extends BaseRouteService {
    public async getInventory(): Promise<string[]> {
        return this.getJsonApi("game/session");
    }
}
